// extracted by mini-css-extract-plugin
export default {"container":"drawn-arrow_container__1uSvE","mask":"drawn-arrow_mask__1XBf9","reverse":"drawn-arrow_reverse__1ewk6"};